import gtm from '@spa/shared/utils/tracking/gtm';
import { transform } from '@spa/offer/utils/tracking';
import { EVENTS } from '@spa/offer/constants/tracking';
import eulerian from '@spa/shared/utils/tracking/eulerian';
import amplitude from '@spa/shared/utils/tracking/amplitude';
import { TRACKING_ACTION_TYPES } from '@spa/shared/store/actions/tracking';
var PROVIDERS = [gtm, eulerian];
export var trackSelectDates = function trackSelectDates() {
  return track(PROVIDERS, transform(EVENTS.CLICK_SELECT_DATES));
};
export var trackRequestToBook = function trackRequestToBook() {
  return track(PROVIDERS, transform(EVENTS.CLICK_REQUEST_TO_BOOK));
};
export var trackRequestIntention = function trackRequestIntention() {
  return track(PROVIDERS, transform(EVENTS.REQUEST_INTENTION));
};
export var trackMoreListings = function trackMoreListings() {
  return track(PROVIDERS, transform(EVENTS.CLICK_MORE_LISTINGS));
};
export var trackMorePlacesLikeThis = function trackMorePlacesLikeThis() {
  return track(PROVIDERS, transform(EVENTS.CLICK_MORE_PLACES_LIKE_THIS));
};
export var trackViewOfferPage = function trackViewOfferPage(_ref) {
  var trackingData = _ref.trackingData,
    notificationEmail = _ref.notificationEmail,
    referrer = _ref.referrer;
  return track([gtm, amplitude], transform(EVENTS.VIEW_OFFER_PAGE, {
    trackingData: trackingData,
    notificationEmail: notificationEmail,
    referrer: referrer
  }));
};
export var trackAddToWishlist = function trackAddToWishlist(_ref2) {
  var offer = _ref2.offer,
    citySlug = _ref2.citySlug,
    neighborhood = _ref2.neighborhood,
    language = _ref2.language;
  return track(PROVIDERS, transform(EVENTS.ADD_TO_WISHLIST, {
    offer: offer,
    citySlug: citySlug,
    neighborhood: neighborhood,
    language: language
  }));
};
export var trackSuggestedDatesShown = function trackSuggestedDatesShown(_ref3) {
  var contractType = _ref3.contractType;
  return track(PROVIDERS, transform(EVENTS.SUGGESTED_DATES_SHOWN, {
    contractType: contractType
  }));
};
export var trackSelectedSuggestedDates = function trackSelectedSuggestedDates() {
  return track(PROVIDERS, transform(EVENTS.SELECTED_SUGGESTED_DATES));
};
export var trackSelectedOriginalDates = function trackSelectedOriginalDates() {
  return track(PROVIDERS, transform(EVENTS.SELECTED_ORIGINAL_DATES));
};
export var trackReportListingOpen = function trackReportListingOpen() {
  return track(PROVIDERS, transform(EVENTS.REPORT_LISTING_OPEN));
};
export var trackReportListingSubmit = function trackReportListingSubmit(_ref4) {
  var reason = _ref4.reason,
    offerId = _ref4.offerId;
  return track([].concat(PROVIDERS, [amplitude]), transform(EVENTS.REPORT_LISTING_SUBMIT, {
    reason: reason,
    offerId: offerId
  }));
};
export var trackShareLink = function trackShareLink() {
  return track(PROVIDERS, transform(EVENTS.SHARE_LINK));
};
export var trackReferralClick = function trackReferralClick(_ref5) {
  var context = _ref5.context;
  return track(PROVIDERS, transform(EVENTS.REFERRAL_CLICK, {
    context: context
  }));
};
export var trackFixedContractModalOpen = function trackFixedContractModalOpen(_ref6) {
  var offerId = _ref6.offerId;
  return track(PROVIDERS, transform(EVENTS.FIXED_CONTRACT_MODAL_OPEN, {
    offer: offerId
  }));
};
export var trackFixedContractOptionClick = function trackFixedContractOptionClick(_ref7) {
  var offerId = _ref7.offerId;
  return track(PROVIDERS, transform(EVENTS.FIXED_CONTRACT_OPTION_CLICK, {
    offer: offerId
  }));
};
export var trackFixedContractConfirmClick = function trackFixedContractConfirmClick(_ref8) {
  var offerId = _ref8.offerId;
  return track(PROVIDERS, transform(EVENTS.FIXED_CONTRACT_CONFIRM_CLICK, {
    offer: offerId
  }));
};
export var trackFixedContractCancelClick = function trackFixedContractCancelClick(_ref9) {
  var offerId = _ref9.offerId;
  return track(PROVIDERS, transform(EVENTS.FIXED_CONTRACT_CANCEL_CLICK, {
    offer: offerId
  }));
};
export var trackOfferPageFaqOpened = function trackOfferPageFaqOpened(_ref10) {
  var question = _ref10.question;
  return track(PROVIDERS, transform(EVENTS.OFFER_PAGE_FAQ_OPENED, {
    question: question
  }));
};
export var trackUniTrustClicked = function trackUniTrustClicked(_ref11) {
  var url = _ref11.url;
  return track(PROVIDERS, transform(EVENTS.UNI_TRUST_CLICKED, {
    url: url
  }));
};
export var trackQuickPageNavigation = function trackQuickPageNavigation(_ref12) {
  var sectionName = _ref12.sectionName;
  return track([amplitude], transform(EVENTS.QUICK_PAGE_NAVIGATION, {
    sectionName: sectionName
  }));
};
export var trackGalleryOpened = function trackGalleryOpened() {
  return track([amplitude], transform(EVENTS.GALLERY_OPENED));
};
export var trackMapOpened = function trackMapOpened() {
  return track([amplitude], transform(EVENTS.MAP_OPENED));
};
export var trackSeeAllAmenities = function trackSeeAllAmenities() {
  return track([amplitude], transform(EVENTS.SEE_ALL_AMENITIES));
};
export var trackAllFeaturesModalOpened = function trackAllFeaturesModalOpened() {
  return track([amplitude], transform(EVENTS.ALL_FEATURES_MODAL_OPENED));
};
export var trackPhotosCarouselOpened = function trackPhotosCarouselOpened() {
  return track([amplitude], transform(EVENTS.PHOTOS_CAROUSEL_OPENED));
};
export var trackQuickGalleryNavigation = function trackQuickGalleryNavigation(_ref13) {
  var label = _ref13.label;
  return track([amplitude], transform(EVENTS.QUICK_GALLERY_NAVIGATION, {
    label: label
  }));
};
export var trackSharedOffer = function trackSharedOffer(_ref14) {
  var method = _ref14.method;
  return track([amplitude], transform(EVENTS.SHARED_OFFER, {
    method: method
  }));
};
export var trackHelpCenter = function trackHelpCenter(_ref15) {
  var destination = _ref15.destination;
  return track([amplitude], transform(EVENTS.HELP_CENTER, {
    destination: destination
  }));
};
export var trackPriceReview = function trackPriceReview(_ref16) {
  var context = _ref16.context;
  return track([amplitude], transform(EVENTS.PRICE_REVIEW, {
    context: context
  }));
};
export var trackRequestToBookAmplitude = function trackRequestToBookAmplitude(_ref17) {
  var moveIn = _ref17.moveIn,
    moveOut = _ref17.moveOut,
    guests = _ref17.guests,
    optionId = _ref17.optionId,
    offerId = _ref17.offerId,
    price = _ref17.price,
    currencyCode = _ref17.currencyCode,
    availableFrom = _ref17.availableFrom,
    propertyType = _ref17.propertyType,
    offerType = _ref17.offerType,
    city = _ref17.city,
    country = _ref17.country,
    offerGenderRestriction = _ref17.offerGenderRestriction,
    propertyGenderRestriction = _ref17.propertyGenderRestriction;
  return track([amplitude], transform(EVENTS.REQUEST_TO_BOOK_AMPLITUDE, {
    moveIn: moveIn,
    moveOut: moveOut,
    guests: guests,
    optionId: optionId,
    offerId: offerId,
    price: price,
    currencyCode: currencyCode,
    availableFrom: availableFrom,
    propertyType: propertyType,
    offerType: offerType,
    city: city,
    country: country,
    offerGenderRestriction: offerGenderRestriction,
    propertyGenderRestriction: propertyGenderRestriction
  }));
};
export var trackFloorPlanOpened = function trackFloorPlanOpened() {
  return track([amplitude], transform(EVENTS.FLOOR_PLAN_OPENED));
};
export var trackVideoOpened = function trackVideoOpened() {
  return track([amplitude], transform(EVENTS.VIDEO_OPENED));
};
export var track = function track(services, data) {
  return {
    type: TRACKING_ACTION_TYPES.TRACK,
    payload: {
      services: services,
      data: data
    }
  };
};